<template>
  <div>
    <div class="mask"></div>
    <div class="dialog">
      <p>{{ prompt_info }}</p>
      <div class="btns">
        <span @click='close(prompt_type_parem.type)'>确认</span>
        <span @click='close()'>取消</span>
      </div>
    </div>
  </div>
</template>

<script>
import {mapGetters} from 'vuex'
export default {
  data () {
    return {

    }
  },
  computed: {
    ...mapGetters([
      'prompt_info',
      'prompt_type_parem',
      'msg_reads'
    ])
  },
  methods: {
    close (type) {
      if (type === 'log_off') {
        this.$store.dispatch('clear_baseinfo')
        this.$store.dispatch('set_prompt_type_param', '')
        this.clearCookie() // 注销清除cookie
        window.localStorage.removeItem('isDrawRemind')
        window.location.reload()
        if (this.msg_reads.msg_reads === 4) {
          this.$router.push('/personalCenter?person_index=0')
        }
      }
      this.$store.dispatch('change_prompt_show', false)
    },
    setCookie (token, exdays) {
      var exdate = new Date() // 获取时间
      exdate.setTime(exdate.getTime() + 24 * 60 * 60 * 1000 * exdays) // 保存的天数
      window.document.cookie = 'Access-Token' + '=' + token + ';path=/;expires=' + exdate.toGMTString()
    },
    clearCookie () {
      this.setCookie('', -1) // 修改2值都为空，天数为负1天即可
    }
  }
}
</script>

<style lang="less" scoped rel="stylesheet/less">
  .mask {
    position: fixed;
    right: 0;
    top: 0;
    bottom: 0;
    left: 0;
    z-index: 5;
    background: rgba(0, 0, 0, 0.5);
  }
  .dialog {
    position: fixed;
    top: 50%;
    left: 50%;
    width: 490px;
    height: 170px;
    color: #333;
    background: #fff;
    -webkit-transform: translate(-50%, -50%);
    -ms-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
    z-index: 9;
    font-size: 16px;
    p {
      padding: 48px 0 36px 0;
    }
    .btns {
      display: table;
      margin: 0 auto;
      span {
        float: left;
        display: block;
        height: 35px;
        padding: 0 56px;
        border: 1px solid #d1434a;
        color: #fff;
        background: #d1434a;
        box-sizing: content-box;
        line-height: 35px;
        cursor: pointer;
        &:nth-child(2) {
          margin-left: 16px;
          color: #d1434a;
          background: #fff;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/common/Prompt.vue